module.exports = __webpack_public_path__ + "img/red.a0443cd1.jpg";